import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  presentation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: '100vw',
    height: 'calc(100vh - 64px)', // 64px == toolbar height
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 24px 0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
  },
  modalHeaderItem: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerTitle: {
    fontSize: fonts.sizes.xxlarge,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.18px',
    lineHeight: '24px',
    color: colors.gray,
    marginLeft: '20px',
  },
  headerIcon: {
    color: colors.gray,
    cursor: 'pointer',
  },
  modalBody: {
    padding: '32px 24px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  gridContent: {
    '& > *': {
      marginTop: '24px',
      display: 'flex',
      alignItems: 'baseline',
    },
    '& > *:first-child': {
      marginTop: 0,
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  formInput: {
    color: colors.black,
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
});

export default useStyles;
